import { LOADER_START, LOADER_STOP } from "../constants/LoaderConstants";

export const loaderAction = (loader) => async (dispatch) => {
  dispatch({ type: loader ? LOADER_START : LOADER_STOP });
};
